//@flow
import {LXi18n} from "lxi18n";
import flatten from "flat";

let localisations = {
    "sv": flatten(require('./js-messages/basicmessages-sv.json'))
};

export function changePageTitle(titleKey, titleDefaultValue){
    return (dispatch, getState) => {
        let languageCode = getState().i18n.currentLanguageKey;
        let lXi18n = new LXi18n(languageCode, localisations);
        lXi18n.localiseTitle(titleKey, titleDefaultValue);
    }
}

export default localisations;


// WEBPACK FOOTER //
// ./src/i18n/localisations.js